// import GridViewIcon from "@mui/icons-material/GridView";
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import Groups3Icon from '@mui/icons-material/Groups3';
import EditIcon from '@mui/icons-material/Edit';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PeopleIcon from '@mui/icons-material/People';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import AbcIcon from '@mui/icons-material/Abc';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { NoteOutlined } from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { ROLES } from './roles';
import PublicIcon from '@mui/icons-material/Public';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import TuneIcon from '@mui/icons-material/Tune';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import TranslateIcon from '@mui/icons-material/Translate';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const sideBarItems = [
  {
    name: 'Batch Tasks',
    img: <AssignmentOutlinedIcon />,
    access: [ROLES.RM, ROLES.CH],
    path: '/batch-tasks',
  },
  {
    name: 'My Courses',
    img: <ImportContactsIcon />,
    access: ['admin', 'user', 'TRAINER', 'TRAINER_SUPER_ADMIN'],
    path: '/courses',
  },
  {
    name: 'Course Mapping',
    img: <Groups3Icon />,
    access: ['admin', 'COURSE_REVIEWER'],
    path: '/courses-mapping',
  },
  {
    name: 'Edit/Upload Courses',
    img: <EditIcon />,
    access: ['admin', 'COURSE_REVIEWER'],
    path: '/edit-courses',
  },
  {
    name: 'Reports',
    img: <AssignmentOutlinedIcon />,
    access: ['admin', 'COURSE_REVIEWER'],
    path: '/reports',
  },
  {
    name: 'Training Module',
    img: <AccountTreeIcon />,
    access: ['TRAINER', 'TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
    // path: "/training/AllTrainings",
    children: [
      {
        name: 'Dashboard',
        img: <DashboardIcon />,
        access: ['TRAINER', 'TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER', 'TR_CLUSTER_MGR'],
        path: '/dashboard',
      },
      {
        name: 'All Trainings',
        img: <PermContactCalendarIcon />,
        access: ['TRAINER', 'TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
        path: '/training/AllTrainings',
      },
      {
        name: 'Create Batch',
        img: <AddIcon />,
        access: ['TRAINER', 'TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
        path: '/training/create-batch',
      },
      {
        name: 'Cluster View',
        img: <ViewModuleIcon />,
        access: ['TR_CLUSTER_MGR'],
        path: '/training/cluster-view',
      },
      {
        name: 'Cluster Config',
        img: <AccountTreeIcon />,
        access: ['TRAINER_MANAGER', 'TRAINER_SUPER_ADMIN'],
        path: '/training/cluster-config',
      },
      {
        name: 'Regions/Circles',
        img: <PublicIcon />,
        access: ['TRAINER_SUPER_ADMIN', 'TR_CLUSTER_MGR', 'TRAINER_MANAGER'],
        path: '/training/regions-circles',
      },
      {
        name: 'Trainers',
        img: <PeopleIcon />,
        access: ['TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
        path: '/training/Trainers',
      },
      {
        name: 'Training Types',
        img: <AbcIcon />,
        access: ['TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
        path: '/training/training-types',
      },
      {
        name: 'Training Configuration',
        img: <TuneIcon />,
        access: ['TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
        path: '/training/training-configuration',
      },

      {
        name: 'Employee Data Lookup',
        img: <PersonSearchIcon />,
        access: ['TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER', 'TRAINER'],
        path: '/employee-data',
      },
      {
        name: 'Certification Logs',
        img: <NoteOutlined />,
        access: ['TRAINER_SUPER_ADMIN', 'TRAINER', 'TRAINER_MANAGER'],
        path: '/training/certification-logs',
      },
      {
        name: 'Training Reports',
        img: <BarChartIcon />,
        access: ['TRAINER_SUPER_ADMIN', 'TR_CLUSTER_MGR', 'TRAINER_MANAGER', 'TRAINER'],
        path: '/training/training-reports',
      },
      {
        name: 'Corrective Branches',
        img: <CheckIcon />,
        access: ['TRAINER', 'TRAINER_SUPER_ADMIN', 'TRAINER_MANAGER'],
        path: '/training/corrective-branches',
      },
    ],
  },
  {
    name: 'Training Calendar',
    img: <CalendarMonthIcon />,
    access: ['SFL_USER', 'SFL_LEARN_ADMIN'],
    path: '/training-calendar',
  },
  {
    name: 'Declaration Section',
    img: <CloudUploadIcon />,
    access: ['admin', 'user'],
    path: '/declaration-section',
  },
  {
    name: 'Training Policies',
    img: <DescriptionIcon />,
    access: ['SFL_USER', 'SFL_LEARN_ADMIN'],
    path: '/sfl-policies',
  },
  {
    name: 'SFL Dashboards',
    img: <DashboardIcon />,
    access: ['SFL_USER', 'SFL_LEARN_ADMIN'],
    path: '/sfl-dashboards',
  },
  {
    name: 'DYK',
    img: <LightbulbIcon />,
    access: ['admin', 'user'],
    path: '/dyk-section',
  },
  {
    name: 'Tasks',
    img: <TaskAltIcon />,
    access: ['admin', 'user', 'LEARN_TASK_ADMIN'],
    path: '/tasks-module', // collapse key only — parent isn't navigated to
    badge: 'assignments', // rolled-up count so it shows when the group is collapsed
    children: [
      {
        name: 'My Assignments',
        img: <AssignmentTurnedInIcon />,
        access: ['user'],
        path: '/my-assignments',
        badge: 'assignments',
      },
      {
        name: 'Translation Tasks',
        img: <AssignmentOutlinedIcon />,
        access: ['LEARN_TASK_ADMIN'],
        path: '/tasks',
      },
      {
        name: 'Language Config',
        img: <TranslateIcon />,
        access: ['LEARN_TASK_ADMIN'],
        path: '/task/language-config',
      },
    ],
  },
];

export default sideBarItems;
